import styles from "./Spinner.module.css";

type SpinnerSize = "sm" | "md" | "lg";

interface SpinnerProps {
  readonly size?: SpinnerSize;
  readonly className?: string;
}

export function Spinner({ size = "md", className }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label="Loading"
      className={`${styles.spinner} ${styles[size]} ${className ?? ""}`}
    />
  );
}
